import { translate }  from './translations';
var browserUpdate = require('browser-update');

let updateText = {
    'msg': translate("browser_outdated_1") + translate("browser_outdated_2"),
    'msgmore': translate("browser_update_detail"), 
    'bupdate': translate("browser_update")
}

browserUpdate(
    {
        required: {
            e:-2,
            f:-3,
            o:-3,
            s:10.1,
            c:"64.0.3282.16817",
            samsung: 7.0,
            vivaldi: 1.2
        },
        insecure: true,
        no_permanent_hide: true,
        url: "https://www.google.com/chrome/",
        text: updateText,
    }
);

(function ($, window, document, undefined) {
    'use strict';

    function worstroads_navigation() {
        var navToggle = $('.navbar-toggle'),
            menu      = $('.full-nav-list');

        navToggle.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            menu.fadeToggle(200);

            $('body').toggleClass('nav-open');
            navToggle.toggleClass('open');
        });
    }
    $(document).ready(function() {
        if ($('.glide').length > 0) {
            var $prevText = $('.gallery-prev-text').text();
            var $nextText = $('.gallery-next-text').text();

            $('.glide').slick({
                dots: false,
                infinite: true,
                arrows: true,
                prevArrow: '<button class="slick-arrow arrow-prev"><span class="screen-reader-text">'+ $prevText +'</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#13B5EA" d="M17.5 23.5a.502.502 0 0 1-.354-.146l-11-11a.5.5 0 0 1 0-.707l11-11a.5.5 0 0 1 .707.707L7.207 12l10.646 10.646a.5.5 0 0 1-.353.854z"/></svg></button>',
                nextArrow: '<button class="slick-arrow arrow-next"><span class="screen-reader-text">'+ $nextText +'</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#13B5EA" d="M6.5 23.5a.5.5 0 0 1-.354-.853L16.793 12 6.146 1.354a.5.5 0 0 1 .707-.707l11 11a.5.5 0 0 1 0 .707l-11 11a.498.498 0 0 1-.353.146z"/></svg></button>',
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 3,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });
        }

        $(function() {
            // lazy loads elements with default selector as '.lozad' 
            const observer = lozad();
            observer.observe();
            // console.log( observer );
            // console.log('loaded');
        });

        // Refocus on control when the featherlight modal is destroyed on close
        $('body').on('click', '.featherlight-close', function(e) {
          $('.arrow-next').focus();
        });

        worstroads_navigation();

        jQuery(document).bind('gform_page_loaded', function(event, form_id, current_page){
            // code to be trigger when next/previous page is loaded
            console.log('Current Page: ' + current_page);
        });

    });
})(jQuery, window, document);

(function ($, window, document, undefined) {
  'use strict';
  jQuery('.road__vote a').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    let $this = jQuery(this);

    if ( $this.find('.loading') ) {
      $this.find('.loading').removeClass('hidden');
    }

    const payload = {
      r: $this.data('road-id'),
      action: 'get_road_information',
      _ajax_nonce: $this.data('nonce')
    }
    
    jQuery.ajax( window.ajax_params.ajaxurl, {
      type: 'POST',
      data: payload,
      dataType: 'json'
    }).always( function() {
      if ( $this.find('.loading') ) {
        $this.find('.loading').addClass('hidden');
      }
    }).done( function( x ) {
      const $modal = jQuery('#topVoteModal');

      if ( ! $modal ) {
        return;
      }

      // Fill information into forms.
      $modal.find('.road_name').text(x.data.road_name);
      $modal.find('.road_locality').text(x.data.road_locality);
      // The road ID input is the only hidden field on this form.
      $modal.find('.road_id_field input').val(x.data.road_id);

      $modal.modal('show');
    }).fail( function() {
      // TODO-KASIA: This shouldn't fail unless it's malicious, but maybe show an error or something/
    });

  });

  // jQuery('#topVoteModal').on('hide', function () {
  //   console.log('Hidden');
  //   $this = $(this);
  //   $this.find('form')[0].reset();
  //   $this.find('.val_summary').remove(); // the validation summary message
  //   $this.find('input[type=text]').val(''); // this appears to be necessary because if a field passes validation and then I reset the form, these fields do not reset for some reason.
  //   $this.find('li.gfield_error div.validation_message').remove(); // remove the validation meesages
  //   $this.find('li.gfield_error').removeClass('gfield_error'); // remove the validation classes.
  // });

})(jQuery, window, document);
